import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { SelectItem, MessageService } from 'primeng/api';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute } from '@angular/router';
import * as fromFeature from '../../../my-features';
import { CryptoService } from '../../../services/crypto.service';

@Component({
  standalone: false,
  selector: 'app-battery-test-result',
  templateUrl: './battery-test-result.component.html',
  styleUrls: ['./battery-test-result.component.css']
})
export class BatteryTestResultComponent implements OnInit {
  private componentDestroyed = new Subject();
  resultDetail_columns_cols: any[] = [
    { field: 'deviceName', header: TRANSLATE('Device Name'), width: '200', class: 'col-nowrap ellipsis', disabled: false },
    { field: 'model', header: TRANSLATE('Model Name'), width: '200', class: 'col-nowrap', disabled: false },
    { field: 'status', header: TRANSLATE('Result'), width: '150', class: 'col-nowrap', disabled: false },
  ];
  result_list = [];
  resultDetail = [];
  currentIndex = 0;
  private deviceDic = {};

  resultDetailInfo: {
    name: string;
    lastRuntime: string;
  } | undefined;
  scedulerId: number;
  scedulerTimeZone: number;
  passCnt = 0;
  failCnt = 0;

  constructor(private router: Router, private translateService: TranslateService, private store: Store<fromStore.State>,
    private messageService: MessageService, private ngxService: NgxUiLoaderService,
    private cryptoService: CryptoService, private route: ActivatedRoute,) {

    const sceduler_obj = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashStr')).split(',');
    if (sceduler_obj !== undefined) {
      this.scedulerId = Number(sceduler_obj[0]);
      this.scedulerTimeZone = Number(sceduler_obj[1]);
      const param = {
        otp: '',
        Id: this.scedulerId
      };
      this.store.dispatch(new fromFeature.LoadBatteryTestSchedulerResult(param));
    } else {
      this.router.navigate(['/index']);
    }

    combineLatest([
      this.store.select(fromStore.getBatteryTestSchedulerResult),
      this.store.select(fromStore.DevicesFiltered)
    ])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([schedulerRes, deviceRes]) => {
        if (!schedulerRes || schedulerRes.isLoading || !schedulerRes.isLoaded || !schedulerRes.entities) {
          return;
        }

        this.result_list = [];
        this.deviceDic = {};

        if (Array.isArray(deviceRes)) {
          deviceRes.forEach(d => {
            if (d && d.dcode !== undefined) {
              this.deviceDic[d.dcode] = d;
            }
          });
        }

        const schedulers = schedulerRes.entities;
        if (schedulers.length > 0) {
          schedulers.forEach(s => {
            const d = new Date((Number(s.ExecTime) * 1000) + (this.scedulerTimeZone * 60 * 60 * 1000));
            const hours = d.getUTCHours();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const h12 = hours % 12 || 12;
            const mm = (d.getUTCMinutes() < 10 ? '0' : '') + d.getUTCMinutes();
            const hh = (h12 < 10 ? '0' : '') + h12;
            const timeStr = this.translateService.instant('Run Time') + ' : ' + d.getUTCFullYear() + '/' + (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + ' ' + hh + ':' + mm + ' ' + ampm;

            this.result_list.push({
              ExecId: s.ExecId,
              LastRunTime: timeStr,
              ExecTime: s.ExecTime,
              Status: s.Status,
              DeviceCount: s.DeviceCount,
              ExecResult: s.ExecResult
            });
          });

          this.currentIndex = 0;
          this.updateCurrentDetail();
        }
      });
  }

  ngOnInit() {
    this.resultDetailInfo = {
      name: '',
      lastRuntime: ''
    }
  }

  updateCurrentDetail() {
    if (this.result_list && this.result_list.length > 0) {
      const currentItem = this.result_list[this.currentIndex];

      this.resultDetailInfo = {
        name: '',
        lastRuntime: currentItem.LastRunTime
      };

      this.resultDetail = [];
      if (Array.isArray(currentItem.ExecResult)) {
        this.passCnt = 0;
        this.failCnt = 0;
        for (let i = 0; i < currentItem.ExecResult.length; i++) {
          const e = currentItem.ExecResult[i];
          const targetDevice = this.deviceDic[String(e.dcode)];
          if (targetDevice) {
            this.resultDetail.push({
              deviceName: targetDevice.name,
              model: targetDevice.Model,
              status: e.Status
            });

            if (e.Status == 0) { //Pass
              this.passCnt++
            } else if (e.Status == 2){ //Fail
              this.failCnt++
            }
          }
        }
      }
    }
  }

  prveTestPlan() {
    if (this.currentIndex < this.result_list.length - 1) {
      this.currentIndex++;
      this.updateCurrentDetail();
    }
  }

  nextTestPlan() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCurrentDetail();
    }
  }

  backClicked() {
    this.router.navigate(['/device-setting']);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }
}
